// action
import {
    DELETE_SCHEDULE_TIME_SLOT,
    DELETE_SCHEDULE_TIME_SLOT_FAIL,
    DELETE_SCHEDULE_TIME_SLOT_SUCCESS,
    DELETE_SCHEDULE_TIME_SLOT_RESET
} from '../action/deleteScheduleTimeSlotAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_SCHEDULE_TIME_SLOT:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_SCHEDULE_TIME_SLOT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_SCHEDULE_TIME_SLOT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_SCHEDULE_TIME_SLOT_RESET:
            return initialState
        default:
            return state
    }
}